// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICardDto
 */
export interface ICardDto {
    /**
     * 
     * @type {number}
     * @memberof ICardDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ICardDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ICardDto
     */
    last4?: string;
    /**
     * 
     * @type {string}
     * @memberof ICardDto
     */
    last2?: string;
    /**
     * 
     * @type {Date}
     * @memberof ICardDto
     * @deprecated
     */
    mailed_on?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ICardDto
     */
    mailed_on_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ICardDto
     */
    activated_on?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ICardDto
     * @deprecated
     */
    expires_on?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ICardDto
     */
    expires_on_date?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof ICardDto
     */
    pin_set?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ICardDto
     */
    created_at?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ICardDto
     */
    readonly modified_at?: Date;
    /**
     * 
     * @type {string}
     * @memberof ICardDto
     */
    card_status?: ICardDtoCardStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ICardDto
     */
    card_type?: ICardDtoCardTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ICardDto
     */
    card_account_id?: number;
    /**
     * 
     * @type {Set<number>}
     * @memberof ICardDto
     */
    account_ids?: Set<number>;
    /**
     * 
     * @type {string}
     * @memberof ICardDto
     */
    organization_path?: string;
    /**
     * 
     * @type {string}
     * @memberof ICardDto
     */
    token_card_id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ICardDto
     */
    employee_unlock_forbidden?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICardDto
     */
    is_verified?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ICardDto
     */
    replacement_initiation_type?: ICardDtoReplacementInitiationTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof ICardDto
     */
    expected_delivery_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ICardDto
     */
    delivery_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ICardDto
     */
    emboss_on_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ICardDto
     */
    lost_stolen_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ICardDto
     */
    demographic_change_date?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof ICardDto
     */
    fraud_confirmed?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ICardDto
     */
    fraud_confirmed_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ICardDto
     */
    deleted_from_processor_on?: Date;
}

/**
* @export
* @enum {string}
*/
export enum ICardDtoCardStatusEnum {
    ACTIVE = 'ACTIVE',
    CLOSED = 'CLOSED',
    PENDING_CLOSED = 'PENDING_CLOSED',
    FROZEN = 'FROZEN',
    LOST = 'LOST',
    PENDING_OPEN = 'PENDING_OPEN',
    PENDING_FROZEN = 'PENDING_FROZEN',
    PENDING_REPLACE = 'PENDING_REPLACE',
    STOLEN = 'STOLEN',
    NOT_SENT = 'NOT_SENT',
    PENDING_UNLOCK = 'PENDING_UNLOCK',
    DAMAGED = 'DAMAGED',
    CLOSING = 'CLOSING',
    DEMOGRAPHIC_CHANGE = 'DEMOGRAPHIC_CHANGE'
}
/**
* @export
* @enum {string}
*/
export enum ICardDtoCardTypeEnum {
    AMEX = 'AMEX',
    VISA = 'VISA',
    MASTERCARD = 'MASTERCARD'
}
/**
* @export
* @enum {string}
*/
export enum ICardDtoReplacementInitiationTypeEnum {
    BANNER = 'BANNER',
    CARDS_PAGE = 'CARDS_PAGE',
    ADMIN_PORTAL = 'ADMIN_PORTAL'
}


/**
 * Check if a given object implements the ICardDto interface.
 */
export function instanceOfICardDto(value: object): value is ICardDto {
    return true;
}

export function ICardDtoFromJSON(json: any): ICardDto {
    return ICardDtoFromJSONTyped(json, false);
}

export function ICardDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICardDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'description': json['description'] == null ? undefined : json['description'],
        'last4': json['last4'] == null ? undefined : json['last4'],
        'last2': json['last2'] == null ? undefined : json['last2'],
        'mailed_on': json['mailed_on'] == null ? undefined : (new Date(json['mailed_on'])),
        'mailed_on_date': json['mailed_on_date'] == null ? undefined : (new Date(json['mailed_on_date'])),
        'activated_on': json['activated_on'] == null ? undefined : (new Date(json['activated_on'])),
        'expires_on': json['expires_on'] == null ? undefined : (new Date(json['expires_on'])),
        'expires_on_date': json['expires_on_date'] == null ? undefined : (new Date(json['expires_on_date'])),
        'pin_set': json['pin_set'] == null ? undefined : json['pin_set'],
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'modified_at': json['modified_at'] == null ? undefined : (new Date(json['modified_at'])),
        'card_status': json['card_status'] == null ? undefined : json['card_status'],
        'card_type': json['card_type'] == null ? undefined : json['card_type'],
        'card_account_id': json['card_account_id'] == null ? undefined : json['card_account_id'],
        'account_ids': json['account_ids'] == null ? undefined : new Set(json['account_ids']),
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'token_card_id': json['token_card_id'] == null ? undefined : json['token_card_id'],
        'employee_unlock_forbidden': json['employee_unlock_forbidden'] == null ? undefined : json['employee_unlock_forbidden'],
        'is_verified': json['is_verified'] == null ? undefined : json['is_verified'],
        'replacement_initiation_type': json['replacement_initiation_type'] == null ? undefined : json['replacement_initiation_type'],
        'expected_delivery_date': json['expected_delivery_date'] == null ? undefined : (new Date(json['expected_delivery_date'])),
        'delivery_date': json['delivery_date'] == null ? undefined : (new Date(json['delivery_date'])),
        'emboss_on_date': json['emboss_on_date'] == null ? undefined : (new Date(json['emboss_on_date'])),
        'lost_stolen_date': json['lost_stolen_date'] == null ? undefined : (new Date(json['lost_stolen_date'])),
        'demographic_change_date': json['demographic_change_date'] == null ? undefined : (new Date(json['demographic_change_date'])),
        'fraud_confirmed': json['fraud_confirmed'] == null ? undefined : json['fraud_confirmed'],
        'fraud_confirmed_date': json['fraud_confirmed_date'] == null ? undefined : (new Date(json['fraud_confirmed_date'])),
        'deleted_from_processor_on': json['deleted_from_processor_on'] == null ? undefined : (new Date(json['deleted_from_processor_on'])),
    };
}

export function ICardDtoToJSON(json: any): ICardDto {
    return ICardDtoToJSONTyped(json, false);
}

export function ICardDtoToJSONTyped(value?: Omit<ICardDto, 'modified_at'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'description': value['description'],
        'last4': value['last4'],
        'last2': value['last2'],
        'mailed_on': value['mailed_on'] == null ? undefined : ((value['mailed_on']).toISOString()),
        'mailed_on_date': value['mailed_on_date'] == null ? undefined : ((value['mailed_on_date']).toISOString().substring(0,10)),
        'activated_on': value['activated_on'] == null ? undefined : ((value['activated_on']).toISOString()),
        'expires_on': value['expires_on'] == null ? undefined : ((value['expires_on']).toISOString()),
        'expires_on_date': value['expires_on_date'] == null ? undefined : ((value['expires_on_date']).toISOString().substring(0,10)),
        'pin_set': value['pin_set'],
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
        'card_status': value['card_status'],
        'card_type': value['card_type'],
        'card_account_id': value['card_account_id'],
        'account_ids': value['account_ids'] == null ? undefined : Array.from(value['account_ids'] as Set<any>),
        'organization_path': value['organization_path'],
        'token_card_id': value['token_card_id'],
        'employee_unlock_forbidden': value['employee_unlock_forbidden'],
        'is_verified': value['is_verified'],
        'replacement_initiation_type': value['replacement_initiation_type'],
        'expected_delivery_date': value['expected_delivery_date'] == null ? undefined : ((value['expected_delivery_date']).toISOString().substring(0,10)),
        'delivery_date': value['delivery_date'] == null ? undefined : ((value['delivery_date']).toISOString().substring(0,10)),
        'emboss_on_date': value['emboss_on_date'] == null ? undefined : ((value['emboss_on_date']).toISOString().substring(0,10)),
        'lost_stolen_date': value['lost_stolen_date'] == null ? undefined : ((value['lost_stolen_date']).toISOString().substring(0,10)),
        'demographic_change_date': value['demographic_change_date'] == null ? undefined : ((value['demographic_change_date']).toISOString().substring(0,10)),
        'fraud_confirmed': value['fraud_confirmed'],
        'fraud_confirmed_date': value['fraud_confirmed_date'] == null ? undefined : ((value['fraud_confirmed_date']).toISOString().substring(0,10)),
        'deleted_from_processor_on': value['deleted_from_processor_on'] == null ? undefined : ((value['deleted_from_processor_on']).toISOString().substring(0,10)),
    };
}

